export const getCurrentLanguageDirection = (appLanguage) => {
  const rtlLanguages = ['ar-AE', 'he-IL'];
  const isRtl = rtlLanguages.some(
    (language) => language === appLanguage && appLanguage.toString()
  );

  return isRtl ? 'rtl' : 'ltr';
};
